import React from 'react';
import { featuredProjects } from '../data/projects';
import { FeaturedProject } from '../types';

export default function FeaturedProjects() {
  return (
    <section id="featured" className="featured-section">
      <div className="wrap">
        <div className="eyebrow">Production Architectures &amp; Frameworks</div>
        <h2 className="sectitle">Featured Open-Source &amp; Platform Builds</h2>
        <p className="secintro">
          Practical production implementations demonstrating multi-agent workflows, state persistence, cyclic state machines, and type-safe frontend delivery platforms.
        </p>

        <div className="featured-grid">
          {featuredProjects.map((proj: FeaturedProject) => (
            <div className="featured-card" key={proj.id}>
              <div className="featured-card-header">
                <div className="featured-badge">{proj.badge}</div>
              </div>

              <h3 className="featured-card-title">{proj.title}</h3>
              <p className="featured-card-tagline">{proj.tagline}</p>
              <p className="featured-card-desc">{proj.desc}</p>

              {proj.architectureNotes && (
                <div className="featured-arch-box">
                  <span className="arch-label">State Machine Flow:</span>
                  <code className="arch-flow">{proj.architectureNotes}</code>
                </div>
              )}

              <div className="featured-highlights-box">
                <div className="highlights-title">Engineering Highlights:</div>
                <ul className="featured-bullets">
                  {proj.highlights.map((hl) => (
                    <li key={`${proj.id}-hl-${hl.slice(0, 24)}`}>{hl}</li>
                  ))}
                </ul>
              </div>

              <div className="featured-stack-row">
                {proj.stack.map((tech) => (
                  <span className="micro-chip" key={tech}>{tech}</span>
                ))}
              </div>

              {(proj.githubUrl || proj.liveUrl) && (
                <div className="featured-card-footer">
                  <div className="featured-links-row">
                    {proj.githubUrl && (
                      <a
                        href={proj.githubUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="featured-gh-link"
                        aria-label={`View ${proj.title} on GitHub`}
                        title="View Source on GitHub"
                      >
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                          <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.53 1.032 1.53 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"/>
                        </svg>
                        <span>Source</span>
                      </a>
                    )}
                    {proj.liveUrl && (
                      <a
                        href={proj.liveUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="featured-gh-link featured-live-link"
                        aria-label={`View ${proj.title} releases or live demo`}
                        title="View Releases or Live Demo"
                      >
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                          <polyline points="15 3 21 3 21 9"></polyline>
                          <line x1="10" y1="14" x2="21" y2="3"></line>
                        </svg>
                        <span>{proj.id === 'flip-clock' ? 'Releases' : 'Live'}</span>
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
